import {createUseMutation, createUseQuery} from "@irati/utils/services/apollo"
import {gql} from "@irati/utils/gql"
import {CreatedFileHandlerResponse, CustomerFileResponse, MutationCreateCustomerFileHandlerArgs, QueryCustomerFileArgs} from "@irati/types"

export const useCustomerFile = createUseQuery<CustomerFileResponse, QueryCustomerFileArgs>(
  gql`
    query CustomerFile($uuid: ID!) {
      customerFile(uuid: $uuid) {
        downloadUrl
        file {
          status
          uuid
        }
      }
    }
  `,
  {
    key: "customerFile",
    forceEU: true
  }
)

export const useCreateCustomerFile = createUseMutation<CreatedFileHandlerResponse, MutationCreateCustomerFileHandlerArgs>(
  gql`
    mutation CreateCustomerFileHandler($name: String!, $mimeType: String!) {
      createCustomerFileHandler(name: $name, mimeType: $mimeType) {
        uuid
        uploadUrl
      }
    }
  `,
  {
    key: "createCustomerFileHandler",
    forceEU: true
  }
)

export const useDeleteCustomerFile = createUseMutation(
  gql`
    mutation DeleteCustomerFile($uuid: ID!) {
      deleteCustomerFile(uuid: $uuid)
    }
  `,
  {
    key: "deleteCustomerFile",
    forceEU: true
  }
)
